module.exports = __webpack_public_path__ + "img/18.ba6d358d.jpg";